
<template>
  <div class="feeDig">
    <el-dialog class="noBacDig" title :visible.sync="digStatus" :modal="ismodal" width="80%"

    >
      <span slot="title" class="commonDiaTitle" align="left">
        <slot name="titleName"></slot>
      </span>
      <transition name="fade4">
        <div class="feeDig" v-if="digStatus">
          <el-image
            style="width: 100%;min-height: 50px;"
            :src="imgUrl?imgUrl:urlGet(id)"
            fit="cover"></el-image>
        </div>
      </transition>
      <span slot="footer" class="dialog-footer">
        <span finger style="position: absolute;top:30px;right: -30px; color: #fff;font-size: 30px;font-weight: 300;" @click="digStatus = false" class="iconfont icon-close"></span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from "vue";
    export default {
      name: "imgDig",
      props: {
        id:{
          type: String,
        },
        visible: {
          type: Boolean,
          default: () => false
        },
        imgUrl:{
          type: String,
          default: () => ""
        },
        ismodal:{
          type:Boolean,
          default:()=>true
        }
      },
      methods:{
        urlGet(id){
          if(!id) return;
          return Vue.prototype.defaults.previewImgBase + "id=" + id + "&access_token=" + JSON.parse(Vue.axios.defaults.token);
        },
      },
      computed: {
        digStatus: {
          get() {
            return this.visible;
          },
          set(value) {
            this.$emit("update:visible", value);
          }
        }
      },
    }
</script>

<style lang="less" scoped>
.feeDig{
  min-height: 200px;
}
</style>
